export default "__VITE_ASSET__Bc12O9V6__"